/** Root for portfolio nav imagery — collection folders + sub-collection files. */
export const PORTFOLIO_NAV_IMG_ROOT = '/imgs/nav/portfolio';

const COLLECTION_SUB_ROUTE_PREFIX = {
  kitchens: 'kitchen',
  bath: 'bath',
  'custom-millwork': 'custom-millwork',
  wardrobe: 'wardrobe',
};

/** Maps sub-collection route slugs to filenames within a collection folder. */
export function subCollectionFileSlug(collectionSlug, subCollectionSlug) {
  const prefix = COLLECTION_SUB_ROUTE_PREFIX[collectionSlug];
  if (prefix && subCollectionSlug.startsWith(`${prefix}-`)) {
    return subCollectionSlug.slice(prefix.length + 1);
  }
  return subCollectionSlug;
}

/**
 * Collection cover image (mega-menu card, portfolio tile fallback).
 * @param {string} collectionSlug — kitchens | bath | custom-millwork | wardrobe
 */
export function portfolioCollectionCoverSrc(collectionSlug) {
  return `${PORTFOLIO_NAV_IMG_ROOT}/${collectionSlug}/cover.jpg`;
}

/** All Collections overview card at portfolio root. */
export const PORTFOLIO_NAV_ALL_COLLECTIONS_SRC = `${PORTFOLIO_NAV_IMG_ROOT}/all-collections.jpg`;

/**
 * Hover carousel slide for a collection tile (portfolio page).
 * @param {string} collectionSlug
 * @param {number} slideIndex — 1-based
 */
export function portfolioCollectionHoverSrc(collectionSlug, slideIndex) {
  return `${PORTFOLIO_NAV_IMG_ROOT}/${collectionSlug}/hover/slide-${slideIndex}.jpg`;
}

/** Collections with local hover slides under {slug}/hover/. */
export const PORTFOLIO_COLLECTION_HOVER_SLIDE_COUNTS = {
  kitchens: 7,
  bath: 10,
  'custom-millwork': 10,
  wardrobe: 9,
};

/**
 * Sub-collection image within its parent collection folder.
 * File name matches the sub-collection route slug (e.g. framed, home-offices).
 * Accessory routes use shortened names: kitchen-accessories → accessories.jpg
 * @param {string} collectionSlug
 * @param {string} subCollectionSlug — route slug from /sub-collections/{slug}
 */
export function portfolioSubCollectionSrc(collectionSlug, subCollectionSlug) {
  const fileSlug = subCollectionFileSlug(collectionSlug, subCollectionSlug);
  return `${PORTFOLIO_NAV_IMG_ROOT}/${collectionSlug}/${fileSlug}.jpg`;
}

/** Expected sub-collection image filenames per collection (for asset placement). */
export const PORTFOLIO_NAV_SUB_COLLECTION_FILES = {
  kitchens: [
    'framed',
    'frameless',
    'contemporary',
    'traditional',
    'transitional',
    'accessories',
    'details-millwork',
  ],
  bath: ['accessories', 'details-millwork'],
  'custom-millwork': [
    'home-offices',
    'mud-room-laundry-room',
    'furniture-pieces',
    'accessories',
    'details-millwork',
  ],
  wardrobe: ['accessories', 'details-millwork'],
};

export const PORTFOLIO_NAV_COLLECTION_COVERS = {
  kitchens: {
    src: portfolioCollectionCoverSrc('kitchens'),
    alt: 'NIICO kitchen cabinetry',
  },
  bath: {
    src: portfolioCollectionCoverSrc('bath'),
    alt: 'NIICO bathroom millwork',
  },
  'custom-millwork': {
    src: portfolioCollectionCoverSrc('custom-millwork'),
    alt: 'NIICO custom millwork',
  },
  wardrobe: {
    src: portfolioCollectionCoverSrc('wardrobe'),
    alt: 'NIICO wardrobe collection',
  },
};

export const PORTFOLIO_NAV_ALL_COLLECTIONS_IMAGE = {
  src: PORTFOLIO_NAV_ALL_COLLECTIONS_SRC,
  alt: 'NIICO millwork collections',
};
